<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M42.6351 13.0003H6.20215C6.45962 12.6754 6.82 12.4273 7.25124 12.3118L38.1609 4.02958C39.2278 3.7437 40.3245 4.37686 40.6104 5.4438L42.6351 13.0003ZM36 16C36 17.1046 35.1046 18 34 18C32.8954 18 32 17.1046 32 16H6C4.89543 16 4 16.8954 4 18V40C4 41.1046 4.89543 42 6 42H32C32 40.8954 32.8954 40 34 40C35.1046 40 36 40.8954 36 42H42C43.1046 42 44 41.1046 44 40V18C44 16.8954 43.1046 16 42 16H36ZM32.5 23C32.5 22.1716 33.1716 21.5 34 21.5C34.8284 21.5 35.5 22.1716 35.5 23C35.5 23.8284 34.8284 24.5 34 24.5C33.1716 24.5 32.5 23.8284 32.5 23ZM34 27.5C33.1716 27.5 32.5 28.1716 32.5 29C32.5 29.8284 33.1716 30.5 34 30.5C34.8284 30.5 35.5 29.8284 35.5 29C35.5 28.1716 34.8284 27.5 34 27.5ZM32.5 35C32.5 34.1716 33.1716 33.5 34 33.5C34.8284 33.5 35.5 34.1716 35.5 35C35.5 35.8284 34.8284 36.5 34 36.5C33.1716 36.5 32.5 35.8284 32.5 35Z"></path>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
